// Shared entrance motion for auth screens.
// Left-side sections drift in from "space" (offset + scale),
// stagger one after another, then settle with a springy overshoot.

export const authFloatContainer = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.98,
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 90,
      damping: 16,
      mass: 0.9,
      staggerChildren: 0.12, // Increased stagger delay for a distinct, smooth cascade
      delayChildren: 0.05,
    },
  },
};

export const authFloatItem = {
  hidden: {
    opacity: 0,
    y: 28,
    scale: 0.95,
    // Removed blur filter to avoid expensive GPU rasterization and prevent frame drops
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 110, // Softer spring for a smoother, premium feel
      damping: 12,    // Allows a gentle overshoot/jiggle settling
      mass: 0.8,
    },
  },
};

